firebird.factory('videoSpeedTestService', [
    '$timeout',
    '$interval',
    '$window',
    'logService',
    'phoneConferenceService',
    'socketService',
    'helperService',
    'analyticsWrapperService',
    'configService',
    'videoGlobalService',
    function (
        $timeout,
        $interval,
        $window,
        logService,
        phoneConferenceService,
        socketService,
        helperService,
        analyticsWrapperService,
        configService,
        videoGlobalService
    ) {
        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoSpeedTestService');

        var service = {
            initialize: initialize
        };

        var self, $scope;

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            // whether to perform speed test or not. Allowed values are
            // false, true (both, default), 'uplink', 'downlink', 'force',
            // or specific speed like '1000-3000' for upload and download.
            self.speedtest = 'downlink';
            self.speedtestBwUp = null;
            self.speedtestBwDown = null;
            self.speedtestTimer = null;
            self.speedtestInterval = 300000; // 5 min.
            self.speedtestTimeout = 30000; // half minute
            self.speedtestWait = 5000; // wait at most 5s for first time.
            self.speedtestWaitTimer = null;
            self.speedtestNetworkData = null;
            self.speedtestCallback = null;
            self.speedtestNetworkChangeAction = null;

            self.initSpeedTest = initSpeedTest;
            self.startSpeedTest = startSpeedTest;
            self.startSpeedTestInternal = startSpeedTestInternal;
            self.stopSpeedTest = stopSpeedTest;
            self.startSpeedTestDownload = startSpeedTestDownload;
            self.logSpeedTestResult = logSpeedTestResult;
            self.onNetworkChangeForSpeedTest = onNetworkChangeForSpeedTest;
            self.logNetworkChange = logNetworkChange;
            self.onDownlinkChange = onDownlinkChange;

            $scope.$on('network-change', self.onNetworkChangeForSpeedTest);
        }

        // update from URL param
        function initSpeedTest() {
            // whether to do speed test or not?
            var speedtest = configService.getValue('speedtest');
            if (speedtest) {
                self.speedtest = speedtest === 'false' ? false : speedtest === 'true' ? true : speedtest;
            } else {
                self.speedtest = 'downlink';
            }

            // how long to wait for speed test first time. default is 5s
            self.speedtestWait = parseInt(configService.getValue('speedtestWait') || '5000');
        }

        // wrapper for speed test internal function. It applies a timeout for first time test,
        // to avoid delaying the initialization for too long. Control the initial timeout using
        // ?speedtestWait= URL parameter.

        function startSpeedTest(reason, callback) {
            var callbackTime = 0;
            var startTime = Date.now();

            self.speedtestWaitTimer = $timeout(function () {
                logService.log('videoroomCtrl - startSpeedTest - wait timeout, invoking callback');
                // took more than wait time.
                self.speedtestWaitTimer = null;
                // pretend that speedtest completed for first time.
                callbackTime = Date.now();
                callback(true);
            }, self.speedtestWait);

            self.startSpeedTestInternal(function (firstTime) {
                if (firstTime) {
                    self.logSpeedTestResult(reason, Math.round(Date.now() - startTime));

                    if (self.speedtestWaitTimer) {
                        // completed before wait time.
                        $timeout.cancel(self.speedtestWaitTimer);
                        self.speedtestWaitTimer = null;
                        // inform that speedtest completed for first time.
                        callback(true);
                    } else {
                        // else alreaady informed that speedtest completed for first time.
                        var now = Date.now();
                        // avoid the callback too quickly after first time, to reduce initial setup load.
                        if (callbackTime && now - callbackTime <= self.speedtestWait * 2) {
                            var delay = self.speedtestWait * 2 - now + callbackTime;
                            logService.log('videoroomCtrl - startSpeedTest - delaying first time callback ' + delay);
                            $timeout(function () {
                                callback();
                            }, delay);
                        } else {
                            logService.log('videoroomCtrl - startSpeedTest - first time callback');
                            callback();
                        }
                    }
                } else {
                    callback();
                }
            });
        }

        // speed test related logic.
        // initiate the speed test, and perform periodically. The callback(true) is invoked first time
        // on completion, and callback(false) on subsequent times.
        // Control the behavior using ?speedtest= URL parameter. A value of false disables speed test.
        // a value like 3000-4000 will use those as up and down bandwidth (kb/s) instead of doing a real
        // test. A value of force, will force perform the download test, instead of using
        // navigator.connection.downlink when available. On Electron, it does not use this because
        // the value were not correct in my local tests.

        function startSpeedTestInternal(callback) {
            if (!self.speedtest) {
                logService.log('videoroomCtrl skipping speed test');
                callback(true);
                return;
            }

            logService.log('videoroomCtrl startSpeedTest: ' + self.speedtest);

            var match = ('' + self.speedtest).match(/^(\d*)\-(\d*)$/);
            if (match) {
                var upload = parseInt(match[1]);
                var download = parseInt(match[2]);
                self.speedtestBwUp = isNaN(upload) ? null : upload;
                self.speedtestBwDown = isNaN(download) ? null : download;
                logService.log('videoroomCtrl user provided speed test upload=' + upload + ', download=' + download);
                callback(true);
                return;
            }

            self.speedtestCallback = callback;
            self.speedtestNetworkChangeAction = null;

            if (self.speedtest == 'uplink') {
                // no need to do downlink speed test
                startSpeedTestUpload(callback, true);
            } else if (
                self.speedtest != 'force' &&
                $window.navigator.connection &&
                $window.navigator.connection.downlink !== undefined &&
                !helperService.isElectron()
            ) {
                self.speedtestNetworkChangeAction = 'downlink';
                self.onDownlinkChange();
            } else {
                if (!self.adjustOnAvailableBandwidth) {
                    // ANYAM-31093 - do not use periodic speed test, but use bandwidth estimation. keep the code for future.
                    self.speedtestTimer = $interval(function () {
                        // TODO: repeating the test without stopping call media will give wrong results.
                        self.startSpeedTestDownload(callback);
                    }, self.speedtestInterval);
                }

                self.startSpeedTestDownload(function () {
                    if (self.speedtest === true || self.speedtest == 'force') {
                        // when download test completed for first time, do upload test once.
                        startSpeedTestUpload(callback, true);
                    } else {
                        callback(true);
                    }
                });
            }

            if (!$window.navigator.connection?.onchange) {
                self.speedtestNetworkChangeAction = 'log';
            }
        }

        // stop the periodic speed test.
        function stopSpeedTest() {
            if (self.speedtestTimer) {
                $interval.cancel(self.speedtestTimer);
                self.speedtestTimer = null;
            }
            if (self.speedtestWaitTimer) {
                $timeout.cancel(self.speedtestWaitTimer);
                self.speedtestWaitTimer = null;
            }
            if (
                self.speedtest &&
                self.speedtest != 'uplink' &&
                self.speedtest != 'force' &&
                $window.navigator.connection &&
                $window.navigator.connection.downlink !== undefined &&
                !helperService.isElectron()
            ) {
                self.speedtestNetworkChangeAction = null;
            }
            if (self.speedtestXhr) {
                self.speedtestXhr.abort();
                self.speedtestXhr = null;
            }
        }

        // perform upload speed test.
        // inspired from https://github.com/librespeed/speedtest/blob/master/speedtest_worker.js
        function startSpeedTestUpload(callback, firstTime) {
            var phoneInfo = phoneConferenceService.getPhoneData();
            var startTime,
                endTime,
                timer = null;
            var uploadSize = 1000000;
            var xhr = (self.speedtestXhr = new XMLHttpRequest());
            xhr.onload = function (event) {
                endTime = Date.now();
                var duration = endTime - startTime;
                self.speedtestBwUp = Math.round((8 * uploadSize) / (duration || 1)); // 8*Bytes/ms => kb/s
                logService.log(
                    'videoroomCtrl speed test upload bandwidth ' +
                        uploadSize +
                        'B in ' +
                        duration +
                        'ms => ' +
                        self.speedtestBwUp
                );
                if (callback) {
                    callback(firstTime);
                    callback = null;
                    delete self.speedtestXhr;
                }
                if (timer) {
                    $timeout.cancel(timer);
                    timer = null;
                }
            };
            xhr.onerror = function (event) {
                logger.warn('startSpeedTestUpload: xhr.onerror', 'speed test failed for upload', event);
                if (callback) {
                    callback(firstTime);
                    callback = null;
                    delete self.speedtestXhr;
                }
                if (timer) {
                    $timeout.cancel(timer);
                    timer = null;
                }
            };
            var uploadUrl = 'https://' + phoneInfo.server + '/speedtest.bin?n=' + ('' + Math.random()).substr(2, 20);
            xhr.open('POST', uploadUrl);
            var r = new ArrayBuffer(Math.floor(uploadSize));
            try {
                r = new Uint32Array(r);
                var maxInt = Math.pow(2, 32) - 1;
                for (var i = 0; i < r.length; ++i) {
                    r[i] = Math.random() * maxInt;
                }
            } catch (e) {}
            var req = new Blob([r]);

            timer = $timeout(function () {
                timer = null;
                if (callback) {
                    logger.warn(
                        'startSpeedTestUpload',
                        'speed test aborted for upload due to timeout, assuming 250 kb/s'
                    );
                    xhr.abort();
                    self.speedtestBwUp = 250;
                    callback(firstTime);
                    callback = null;
                    delete self.speedtestXhr;
                }
            }, self.speedtestTimeout);
            xhr.withCredentials = true;
            startTime = Date.now();
            xhr.send(req);
        }

        // if speed test is to be performed, then download two images - one is a 1 pixel image
        // with total size (70B) and other is large image with size (1MB). The difference in duration
        // of download of these will determine the duration needed to download the extra bytes,
        // whereas the overhead will be absorbed in the difference. The overhead is for connection
        // setup, headers, etc. If the download test cannot be completed in 30 seconds, it aborts
        // the test with an error.
        function startSpeedTestDownload(callback) {
            var phoneInfo = phoneConferenceService.getPhoneData();
            var startTime0, endTime0, startTime1, endTime1, timer;
            var downloadSize = 1000000;
            var download0 = new Image();
            var download1 = new Image();

            var onerror = function (event) {
                if (!callback) {
                    return;
                }
                if (timer) {
                    $timeout.cancel(timer);
                    timer = null;
                }
                logger.warn('startSpeedTestDownload', 'error in download speed test', event);
                callback();
            };

            download0.onload = function () {
                if (!callback) {
                    return;
                }

                endTime0 = Date.now();
                var duration0 = endTime0 - startTime0;

                download1.onload = function () {
                    if (!callback) {
                        return;
                    }
                    if (timer) {
                        $timeout.cancel(timer);
                        timer = null;
                    }
                    endTime1 = Date.now();
                    var duration1 = endTime1 - startTime1;
                    if (duration1 > duration0) {
                        self.speedtestBwDown = Math.round((8 * downloadSize) / (duration1 - duration0));
                    } else {
                        logService.log(
                            'videoroomCtrl speed test could not use base line download duration: ' +
                                duration0 +
                                ' > ' +
                                duration1
                        );
                        self.speedtestBwDown = Math.round((8 * downloadSize) / duration1);
                    }
                    logService.log(
                        'videoroomCtrl download speed test ' +
                            downloadSize +
                            'B in ' +
                            duration1 +
                            'ms ' +
                            ' baseline is ' +
                            duration0 +
                            'ms => ' +
                            self.speedtestBwDown +
                            ' kb/s'
                    );
                    callback();
                };
                download1.onerror = onerror;

                var imageSrc1 =
                    'https://' + phoneInfo.server + '/speedtest.jpg?n=' + ('' + Math.random()).substr(2, 20);
                startTime1 = Date.now();
                download1.src = imageSrc1;
            };
            download0.onerror = onerror;

            timer = $timeout(function () {
                timer = null;
                if (endTime1 === undefined) {
                    logger.warn(
                        'startSpeedTestDownload',
                        'cancel download speed test due to timeout, assuming 250 kb/s'
                    );
                    self.speedtestBwDown = 250;
                    callback();
                    callback = null;
                    var onepixel =
                        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+P+/HgAFhAJ/wlseKgAAAABJRU5ErkJggg==';
                    if (download0) {
                        download0.src = onepixel;
                    }
                    if (download1) {
                        download1.src = onepixel;
                    }
                }
            }, self.speedtestTimeout);

            var imageSrc0 = 'https://' + phoneInfo.server + '/speedtest0.png?n=' + ('' + Math.random()).substr(2, 20);
            startTime0 = Date.now();
            download0.src = imageSrc0;
        }

        function onNetworkChangeForSpeedTest(event) {
            logger.log('onNetworkChangeForSpeedTest', self.speedtestNetworkChangeAction);

            if (self.speedtestNetworkChangeAction === 'log') {
                self.logNetworkChange();
            } else if (self.speedtestNetworkChangeAction === 'downlink') {
                self.onDownlinkChange(event);
            }
        }

        function logNetworkChange() {
            // log in msgflow about network change event, atmost once per second.
            if ($window.navigator.connection) {
                $timeout(function () {
                    // collate multiple change events within small interval.
                    // if type is undefined, then use online/offline state.
                    var data = {
                        type: $window.navigator.connection?.type || ($window.navigator.onLine ? 'online' : 'offline'),
                        effective: $window.navigator.connection?.effectiveType,
                        downlink: $window.navigator.connection?.downlink,
                        rtt: $window.navigator.connection?.rtt
                    };
                    if (JSON.stringify(self.speedtestNetworkData) != JSON.stringify(data)) {
                        self.speedtestNetworkData = data;
                        self.msgflowEvent('network-change:' + data.type, data);
                        self.resetVideoStats('network-change');
                    }
                }, 10);
            }
        }

        function onDownlinkChange(event) {
            self.speedtestBwDown = Math.round($window.navigator.connection?.downlink * 1000); // mb/s to kb/s

            logService.log(
                `videoroomCtrl speed test navigator.connection.downlink changed to ${$window.navigator.connection?.downlink}`
            );

            if (event === undefined) {
                if (self.speedtest === true) {
                    // need uplink speed test too
                    startSpeedTestUpload(self.speedtestCallback, true);
                } else {
                    // no uplink speed test
                    self.speedtestCallback(true);
                }
            } else {
                self.logNetworkChange();
                self.speedtestCallback();
            }
        }

        // log the speed test results to server, and analytics, similar to vertoService
        function logSpeedTestResult(reason, duration) {
            // $rootScope.$broadcast('bandwidth-state-changed');

            if (self.speedtestBwUp || self.speedtestBwDown) {
                socketService.send({
                    message: 'attendee-connectivity-updated',
                    data: {
                        bandwidth: { up: self.speedtestBwUp, down: self.speedtestBwDown }
                    }
                });
            }

            if (self.speedtestBwUp) {
                const rating = self.speedtestBwUp > 4000 ? 'great' : self.speedtestBwUp >= 1000 ? 'adequate' : 'low';
                analyticsWrapperService.eventTrack('Meeting - ' + rating + ' upload bandwidth', {
                    sfuEvent: true
                });
            }

            if (
                self.speedtestBwDown &&
                (reason !== 'networkCollectMoreStatsAfter' ||
                    self.speedtestBwDown < self.networkState.moreStats.speedtestBwDownThreshold)
            ) {
                const rating2 =
                    self.speedtestBwDown > 4000 ? 'great' : self.speedtestBwDown >= 1000 ? 'adequate' : 'low';
                analyticsWrapperService.eventTrack('Meeting - ' + rating2 + ' download bandwidth', {
                    sfuEvent: true
                });
            }

            if (self.speedtestBwUp || self.speedtestBwDown) {
                const range =
                    (self.speedtestBwUp === null || self.speedtestBwUp > 4000) &&
                    (self.speedtestBwDown === null || self.speedtestBwDown > 5000)
                        ? 'high'
                        : (self.speedtestBwUp !== null && self.speedtestBwUp < 1000) ||
                          (self.speedtestBwDown !== null && self.speedtestBwDown < 1000)
                        ? 'low'
                        : 'medium';
                self.msgflowEvent('speedtest:' + range, {
                    up: self.speedtestBwUp,
                    down: self.speedtestBwDown,
                    duration: duration
                });
            }
        }
    }
]);
